// Body of the "The Science of k2dex" article (rendered by ArticlePage at
// /articles/the-science-of-k2dex; the legacy /science URL redirects here).
// Imports KaTeX CSS once; renders each section in order.

import { useEffect } from "react";
import { Magnets } from "../science/sections/Magnets";
import { Lattice } from "../science/sections/Lattice";
import { Graph } from "../science/sections/Graph";
import { Metropolis } from "../science/sections/Metropolis";
import { ParallelTempering } from "../science/sections/ParallelTempering";
import { MeanField } from "../science/sections/MeanField";
import { SCOTUS } from "../science/sections/SCOTUS";
import { Pokemon } from "../science/sections/Pokemon";
import { References } from "../science/sections/References";

export function SciencePage() {
  useEffect(() => {
    import("katex/dist/katex.min.css");
  }, []);
  return (
    <div className="lab-science">
      <header className="lab-science-header">
        <p className="lab-science-lede">
          Fitting a pairwise binary Markov random field by regularized moment matching
          and sampling the resulting Boltzmann distribution with parallel-tempered Markov
          chain Monte Carlo
          <span className="lab-science-lede-punch">(to get better at Pokémon)</span>
        </p>
        <h1>The science behind k2dex</h1>
      </header>
      <h2 className="lab-science-act">The Ising Model</h2>
      <Magnets />
      <Lattice />
      <Graph />
      <h2 className="lab-science-act">MCMC Sampling</h2>
      <Metropolis />
      <ParallelTempering />
      <MeanField />
      <h2 className="lab-science-act">The Inverse Problem</h2>
      <SCOTUS />
      <Pokemon />
      <References />
    </div>
  );
}
export default SciencePage;
